var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdm-stripe',{attrs:{"text":_vm.trend.sticker_label,"size":_vm.size,"color":_vm.trend.sticker_bg_color}})}
var staticRenderFns = []

export { render, staticRenderFns }